import { Account } from '@/core/api/entities/account/account'
import { capitalizeFirstLetter } from '@/shared/utils/helpers'

export interface BrandTag {
	id: number
	display: string
}

export interface DemographicTag {
	key: string
	display: string
}

export const mapBrandIdentitiesToTags = (
	brandIdentities: Array<{ id: number; name?: string; key?: string }>
): BrandTag[] => {
	return brandIdentities.map((identity) => ({
		id: identity.id,
		display: capitalizeFirstLetter(identity.name || identity.key || ''),
	}))
}

export const mapDemographicGroupsToTags = (
	groups: Array<{ key: string }>,
	t?: any
): DemographicTag[] => {
	return groups.map((group) => {
		const normalizedKey = group.key.toLowerCase()

		// Handle age groups with special formatting
		if (normalizedKey === 'adult_a' || normalizedKey === 'adult_b') {
			const fallback = normalizedKey === 'adult_a' ? 'Adults A' : 'Adults B'

			return {
				key: group.key,
				display: t
					? t(`account.brand.demographics.${normalizedKey}`, fallback)
					: fallback,
			}
		}

		// Handle socioeconomic levels with translations
		const socioeconomicKeys = [
			'luxury_clientele',
			'premium_seekers',
			'middle_range_buyers',
			'budget_conscious',
			'indifferent',
		]
		if (socioeconomicKeys.includes(normalizedKey) && t) {
			const fallback = capitalizeFirstLetter(group.key.replace(/_/g, ' '))
			return {
				key: group.key,
				display: t(`auth:registerStep5.socioeconomicLevels.${normalizedKey}`, {
					defaultValue: fallback,
				}),
			}
		}

		return {
			key: group.key,
			display: capitalizeFirstLetter(group.key),
		}
	})
}

export const getAccountFormDefaults = (account?: Account) => {
	return {
		parent_business_category_id: account?.businessCategory?.parentId || null,
		business_category_id: account?.businessCategoryId || null,
		business_category_description: account?.businessCategoryDescription ?? null,
	}
}
